export class DonationsReport {
    ProjectName:string|null=null 
    ProjectId:number|null=null 
    FromDate:string|null=null 
    ToFrom:string|null=null 
    
}
